export const orderRequestStatuses = {
  accepted: 'ACCEPTED',
  rejected: 'REJECTED',
  pending: 'PENDING',
  cancelled: 'CANCELLED',
  processing: 'PROCESSING',
  processed: 'PROCESSED',
  failed: 'FAILED',
};